// extracted by mini-css-extract-plugin
export default {"wrapper":"Admin_wrapper__ZXF1G","tabs":"Admin_tabs__RskAf"};